export {};
//# sourceMappingURL=User.js.map